import { useCallback, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ToastContext } from "./toast-context";
import styles from "./toast.module.css";

interface ToastItem {
	id: number;
	message: string;
	type: "success" | "error";
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
	const [toasts, setToasts] = useState<ToastItem[]>([]);
	const counter = useRef(0);

	const dismiss = useCallback((id: number) => {
		setToasts((prev) => prev.filter((t) => t.id !== id));
	}, []);

	const showToast = useCallback(
		(message: string, type: "success" | "error" = "success") => {
			const id = ++counter.current;
			setToasts((prev) => [...prev, { id, message, type }]);
			// Hata bildirimleri SAP mesajını da taşıdığı için okunacak kadar uzun kalır.
			setTimeout(() => dismiss(id), type === "error" ? 12000 : 6000);
		},
		[dismiss],
	);

	return (
		<ToastContext.Provider value={{ showToast }}>
			{children}
			{createPortal(
				<div className={styles.container}>
					{toasts.map((t) => (
						<div
							key={t.id}
							className={`${styles.toast} ${styles[t.type]}`}
							onClick={() => dismiss(t.id)}
							style={{ cursor: "pointer" }}
						>
							{t.message}
						</div>
					))}
				</div>,
				document.body,
			)}
		</ToastContext.Provider>
	);
}
